<template>
    <div class="popover_select">
        <div class="text">{{title}}</div>
        <el-select
                v-model="selectValue"
                size="mini"
                style="width: 150px"
                placeholder="请选择">
            <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
        </el-select>
        <el-button type="primary" size="mini" icon="el-icon-check" @click="submit" circle></el-button>
        <el-button icon="el-icon-close" size="mini" @click="close" circle></el-button>
    </div>
</template>

<script>
    export default {
        name: "PopoverSelect",
        props: {
            title: {
                type: String,
                default: '请选择'
            },
            defaultValue: {
                type: Number,
                default: 4
            },
            typeList: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data () {
            return {
                selectValue: this.defaultValue
            }
        },
        methods: {
            submit () {
                this.$emit('submit', this.selectValue)
            },
            close () {
                this.$emit('close')
            },
        }
    }
</script>

<style lang="scss" scoped>
    .popover_select{
        .text{
            border-bottom: 1px solid #ebebeb;
            padding-bottom: 10px;
            margin-bottom: 15px;
        }
        button{
            margin-left: 5px;
        }
    }
</style>
